import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {DropdownComponent} from '../../../../shared/components/controls/ui-controls/dropdown/dropdown.component';
import {SectionComponent} from '../../../../shared/components/structure/section/section.component';
import {Anliegen, Subanliegen} from '../../../../core/model/anliegen';
import {NgClass} from '@angular/common';
import {I18NextPipe} from "@kokos-i18next";

type DropdownOption = { label: string; value: string };

@Component({
    selector: 'kokos-anliegen-selector',
    imports: [DropdownComponent, SectionComponent, NgClass, I18NextPipe],
    templateUrl: './anliegen-selector.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
})
export class AnliegenSelectorComponent implements OnChanges {
    @Input() anliegenList: ReadonlyArray<Anliegen> = [];
    @Input() subanliegenList: ReadonlyArray<Subanliegen> = [];

    @Input() anliegen: Anliegen | null = null;
    @Input() subanliegen: Subanliegen | null = null;

    @Input() showLoading = false;

    @Output() readonly anliegenChanged = new EventEmitter<string>();
    @Output() readonly subanliegenChanged = new EventEmitter<string>();

    dropdownAnliegenOptions: DropdownOption[] = [];
    dropdownSubanliegenOptions: DropdownOption[] = [];

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['anliegenList']) {
            this.dropdownAnliegenOptions = toDropdownOptions(this.anliegenList);
        }
        if (changes['subanliegenList']) {
            this.dropdownSubanliegenOptions = toDropdownOptions(this.subanliegenList);
        }
    }
}

function toDropdownOptions<T extends { id: string; name: string }>(list: ReadonlyArray<T>): DropdownOption[] {
    return list.map(item => ({label: item.name, value: item.id}));
}
